import { render, staticRenderFns } from "./recommend_price.vue?vue&type=template&id=5f294b18&scoped=true&"
import script from "./recommend_price.vue?vue&type=script&lang=ts&"
export * from "./recommend_price.vue?vue&type=script&lang=ts&"
import style0 from "./recommend_price.vue?vue&type=style&index=0&id=5f294b18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f294b18",
  null
  
)

export default component.exports